import { JsonViewerDialog } from './JsonViewerDialog';
import { UserViewerDialog } from './UserViewerDialog';

import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from '@/components/ui/Table';
import { AuditLog } from '@/services/AuditLogs';

interface LogsTableProps {
  filteredLogs: AuditLog[];
}

export function LogsTable({ filteredLogs }: LogsTableProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-2">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User ID</TableHead>
            <TableHead>Customer ID</TableHead>
            <TableHead>Action</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Changes</TableHead>
            <TableHead>Created At</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredLogs.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={6}
                className="py-8 text-center text-gray-500"
                style={{ height: '300px', verticalAlign: 'middle' }}
              >
                No audit logs found matching the selected filters.
              </TableCell>
            </TableRow>
          ) : (
            filteredLogs.map((log) => (
              <TableRow key={log.id} className="hover:bg-gray-100">
                <TableCell className="font-mono text-sm">
                  <UserViewerDialog userId={log.userId} />
                </TableCell>
                <TableCell className="font-mono text-sm">
                  {log.customerId ?? 'null'}
                </TableCell>
                <TableCell>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
                    {log.action}
                  </span>
                </TableCell>
                <TableCell>{log.description}</TableCell>
                <TableCell>
                  {log.changes && Object.keys(log.changes).length > 0 ? (
                    <JsonViewerDialog data={log.changes} />
                  ) : (
                    <span className="text-sm text-gray-500">No changes</span>
                  )}
                </TableCell>
                <TableCell className="text-sm text-gray-600">
                  {new Date(log.createdAt).toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
